import React, { FC }           from 'react';
import { History }             from 'history';
import { ICreditUnion }        from '@typings/accountManagement';
import { AccountPageWrapper }  from '@modules/accountManagement/components/AccountPageWrapper';
import { StatisticsContainer } from '@modules/dashboard/containers/StatisticsContainer';

interface IProps extends Pick<History, 'push'> {
  cuInfo: ICreditUnion;
}

export const AccountStatisticsPage: FC<IProps> = ({ cuInfo, push }) => (
  <AccountPageWrapper
    push   = {push}
    cuInfo = {cuInfo}
  >
    <StatisticsContainer
      cuid   = {cuInfo.cuid}
      cuName = {cuInfo.name}
      push   = {push}
    />
  </AccountPageWrapper>
);
